export interface Notification {
  id: number;
  user_id: number;
  type: "default" | "progress";
  title: string;
  message: string;
  is_read: boolean;
  progress?: number;
  category?: "info" | "warning" | "error" | "success";
  priority: "low" | "medium" | "high";
  attachment_url?: string;
  source?: "system" | "user" | "api" | "agent";
  expires_at?: Date;
  created_at: Date;
  updated_at: Date;
}

export enum CategoryColors {
  info = "#2196f3",
  warning = "#ff9800",
  error = "#f44336",
  success = "#4caf50",
  default = "#f44336",
}

export enum PriorityColors {
  low = "#4caf50",
  medium = "#ffeb3b",
  high = "#f44336",
  default = "#f44336",
}

export enum SourceColors {
  system = "#2196f3",
  user = "#ff9800",
  agent = "#ffeb3b",
  api = "#4caf50",
  default = "#f44336",
}
